module.exports = __webpack_public_path__ + "media/newstyle/images/100-mil-book-aus-d5e525edf21bd737c9c00a4b80072c89.svg";